import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-scroll'

import { AnchorIcon } from '@wf-sl/common-icons'

import styles from './anchor-element.module.css'

const propTypes = {
    anchor: PropTypes.string.isRequired,
    anchorName: PropTypes.string,
    containerId: PropTypes.string.isRequired
}

/**
 * Creates an anchor link besides the card headline.
 * @param {object} props Properties for the anchor link configuration.
 * @param {string} props.anchor The anchor link.
 * @param {string} props.containerId The containerId for the anchor
 * @param {string} [props.anchorName=props.anchor] The name for the anchor link.
 * @returns {ReactElement}
 */
const AnchorElement = props => {
    const { anchor, anchorName, containerId } = props
    const linkText = anchorName || anchor

    return (
        <Link to={anchor} className={styles['link-section']} spy smooth containerId={containerId} duration={500}>
            <AnchorIcon width={24} height={18} className={styles['anchor-icon']} />
            {linkText}
        </Link>
    )
}

AnchorElement.propTypes = propTypes

export default AnchorElement
